import React from 'react'

export const AvatarGroup = (props) => {
  return <div className="flex -space-x-3 overflow-hidden isolate">{props.children}</div>
}

export default AvatarGroup
